import { useTranslation } from 'react-i18next';

import { ResponseRequestHistoryView } from './ResponseRequestHistoryView';
import { useResponseRequestHistory } from './useResponseRequestHistory';

export interface ResponseRequestHistoryProps {
  responseId: string;
}

/**
 * The history of "request further information" messages sent against one
 * questionnaire response (CUS-243).
 *
 * Renders NOTHING when there is no history — no empty state, no placeholder
 * heading. That is an explicit acceptance criterion ("no empty placeholder or
 * noise"), and it also makes the block inert on V2: with the `trpc` flag off
 * nothing is ever persisted, so the list is always empty and the section never
 * appears.
 *
 * Nothing is rendered while loading either. The page already polls its own
 * feed on a 5s interval, so a spinner appearing and vanishing below the form
 * on every poll would be worse than the section simply arriving.
 */
export const ResponseRequestHistory = ({
  responseId,
}: ResponseRequestHistoryProps) => {
  const { t } = useTranslation(['common'], {
    keyPrefix: 'third_party_responses.request_history',
  });
  const { entries, loading } = useResponseRequestHistory(responseId);

  if (loading || entries.length === 0) {
    return null;
  }

  return (
    <ResponseRequestHistoryView
      entries={entries}
      lang={{
        title: t('title'),
        unknownAuthor: t('unknown_author'),
      }}
    />
  );
};
